var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event)?_c('Modal',{attrs:{"searchQuery":"","closeModal":_vm.closeLiveOddsModal},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var searchValue = ref.searchValue;
return _c('LiveOddsList',{attrs:{"searchValue":searchValue,"markets":_vm.markets}})}}],null,false,262707544)},[_c('LiveOddsHeader',{attrs:{"slot":"modal-header","event":_vm.event},slot:"modal-header"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }